import { render, staticRenderFns } from "./Template10.vue?vue&type=template&id=b62f1464"
import script from "./Template10.vue?vue&type=script&lang=js"
export * from "./Template10.vue?vue&type=script&lang=js"
import style0 from "./Template10.vue?vue&type=style&index=0&id=b62f1464&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports